<template>
  <div id="currency">
    <div class="update-box">
      <div class="material-info">
        <div class="material-details">
          <div class="img-details">
            <div class="title">第一学历</div>
            <div class="img-box" v-if="imgFirstInfo">
              <el-image :src="imgFirstInfo.url"></el-image>
              <el-image-viewer
                v-if="showViewer=='First'"
                :on-close="()=>{showViewer=-1}"
                :url-list="[imgFirstInfo.url]"
              />
              <div class="img-info">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="imgFirstInfo.fileName"
                  placement="top"
                >
                  <div class="img-name">{{imgFirstInfo.fileName|valLength(15)}}</div>
                </el-tooltip>
                <div class="img-size">文件大小：{{imgFirstInfo.length|changeSize}}</div>
                <div class="img-btn">
                  <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false"
                    :multiple="false"
                    :before-upload="beforeAvatarUpload"
                    :http-request="uplaodFirstMaterialsInfo"
                    :disabled="isDisabled"
                    @click.native="showDisable"
                  >重新上传</el-upload>
                  <div class="btn" @click="showViewer='First'">预览</div>
                  <div class="btn" @click="downLoadFile(imgFirstInfo)">下载</div>
                  <div class="btn" @click="deltetOpen('第一学历',imgFirstInfo)">删除</div>
                </div>
              </div>
            </div>
            <div class="img-update" v-else>
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                drag
                list-type="picture-card"
                :show-file-list="false"
                :multiple="false"
                :before-upload="beforeAvatarUpload"
                :http-request="uplaodFirstMaterialsInfo"
                :disabled="isDisabled"
                @click.native="showDisable"
              >
                <div class="upload-tips">
                  <span>点击上传</span>/拖拽到此区域
                </div>
              </el-upload>
            </div>
          </div>
          <div class="img-details">
            <div class="title">第二学历</div>
            <div class="img-box" v-if="imgSecondInfo">
              <el-image :src="imgSecondInfo.url"></el-image>
              <el-image-viewer
                v-if="showViewer=='Second'"
                :on-close="()=>{showViewer=-1}"
                :url-list="[imgSecondInfo.url]"
              />
              <div class="img-info">
                <div class="img-name">{{imgSecondInfo.fileName|valLength(15)}}</div>
                <div class="img-size">文件大小：{{imgSecondInfo.length|changeSize}}</div>
                <div class="img-btn">
                  <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false"
                    :multiple="false"
                    :before-upload="beforeAvatarUpload"
                    :http-request="uplaodSecondMaterialsInfo"
                    :disabled="isDisabled"
                    @click.native="showDisable"
                  >重新上传</el-upload>
                  <div class="btn" @click="showViewer='Second'">预览</div>
                  <div class="btn" @click="downLoadFile(imgSecondInfo)">下载</div>
                  <div class="btn" @click="deltetOpen('第二学历',imgSecondInfo)">删除</div>
                </div>
              </div>
            </div>
            <div class="img-update" v-else>
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                drag
                list-type="picture-card"
                :show-file-list="false"
                :multiple="false"
                :before-upload="beforeAvatarUpload"
                :http-request="uplaodSecondMaterialsInfo"
                :disabled="isDisabled"
                @click.native="showDisable"
              >
                <div class="upload-tips">
                  <span>点击上传</span>/拖拽到此区域
                </div>
              </el-upload>
            </div>
          </div>
          <div class="img-details">
            <div class="title">第三学历</div>
            <div class="img-box" v-if="imgThirdInfo">
              <el-image :src="imgThirdInfo.url"></el-image>
              <el-image-viewer
                v-if="showViewer=='Third'"
                :on-close="()=>{showViewer=-1}"
                :url-list="[imgThirdInfo.url]"
              />
              <div class="img-info">
                <div class="img-name">{{imgThirdInfo.fileName|valLength(15)}}</div>
                <div class="img-size">文件大小：{{imgThirdInfo.length|changeSize}}</div>
                <div class="img-btn">
                  <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false"
                    :multiple="false"
                    :before-upload="beforeAvatarUpload"
                    :http-request="uplaodThirdMaterialsInfo"
                    :disabled="isDisabled"
                    @click.native="showDisable"
                  >重新上传</el-upload>
                  <div class="btn" @click="showViewer='Third'">预览</div>
                  <div class="btn" @click="downLoadFile(imgThirdInfo)">下载</div>
                  <div class="btn" @click="deltetOpen('第三学历',imgThirdInfo)">删除</div>
                </div>
              </div>
            </div>
            <div class="img-update" v-else>
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                drag
                list-type="picture-card"
                :show-file-list="false"
                :multiple="false"
                :before-upload="beforeAvatarUpload"
                :http-request="uplaodThirdMaterialsInfo"
                :disabled="isDisabled"
                @click.native="showDisable"
              >
                <div class="upload-tips">
                  <span>点击上传</span>/拖拽到此区域
                </div>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMaterials,
  uploadMaterials,
  deleteMaterials,
  downloadMaterials,
} from "@/http/api/employe";

export default {
  name: "Index",
  components: {
    "el-image-viewer": () =>
      import("@aiwins/admin-ui/packages/image/src/image-viewer"),
  },
  props: {
    isLoadingImg: Boolean,
  },
  data() {
    return {
      headerText: this.$route.query.type,
      id: this.$route.params.id,
      imgFirstInfo: "",
      imgSecondInfo: "",
      imgThirdInfo: "",
      showViewer: -1,
      loadingImg: true,
      isPIC: true,
      isLt5M: true,
      isDisabled: true,
      permissions: this.$store.getters.permissions,
    };
  },
  mounted() {
    this.getMaterialList();
    this.isDisabled = !this.permissions["RocketIdentity.Users.UploadMaterials"];
  },
  watch: {
    isLoadingImg(val) {
      this.loadingImg = this.isLoadingImg;
    },
  },
  methods: {
    showDisable() {
      if (this.isDisabled) {
        this.$message.warning({
          message: `您暂无电子档案上传权限`,
          showClose: true,
        });
      }
    },
    downLoadFile(item) {
      if (this.permissions["RocketIdentity.Users.DownloadMaterials"]) {
        var data = item.url.split("/");
        var name = data[data.length - 1];
        downloadMaterials(this.id,query).then(res=>{
          //console.log(res,'获取的下载数据');
          const content = res;
          //console.log(res);
          const blob = new Blob([content]);
          if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a')
            elink.download = name
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          } else { // IE10+下载
            navigator.msSaveBlob(blob, name)
          }
        })
        // window.open(
        //   `https://api-dev.zhilexinfang.com/api/deer/users/${this.id}/download-materials?fileName=${name}`
        // );
      } else {
        this.$message.warning({
          message: `您暂无电子档案下载权限`,
          showClose: true,
        });
      }
    },
    deltetOpen(val, file) {
      if (this.permissions["RocketIdentity.Users.ManageMaterials"]) {
        //console.log(file, "获取的file");
        this.$confirm(`你确定要删除吗?`, "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.deltetMaterial(val, file);
            //console.log(1111111111111);
          })
          .catch(() => {
            //console.log("取消删除");
          });
      } else {
        this.$message.warning({
          message: `您暂无电子档案管理权限`,
          showClose: true,
        });
      }
    },
    deltetMaterial(val, file) {
      //console.log(val, "获取的删除信息");
      let data = `?Type=${val}&MaterialIds=${file.id}`;
      deleteMaterials(this.id, data).then((res) => {
        //console.log(res, "删除后");
        this.$message({
          message: "资料删除成功！",
          type: "success",
        });
        this.getMaterialList();
      });
    },
    getMaterialList() {
      this.imgFirstInfo = null;
      this.imgSecondInfo = null;
      this.imgThirdInfo = null;
      let query = `?types=第一学历&types=第二学历&types=第三学历`;
      getMaterials(this.id, query).then((res) => {
        res.result.items.map((item) => {
          if (item.type == "第一学历") {
            this.imgFirstInfo = item;
          } else if (item.type == "第二学历") {
            this.imgSecondInfo = item;
          } else if (item.type == "第三学历") {
            this.imgThirdInfo = item;
          }
        });
        this.loadingImg = false;
        setTimeout(() => {
          this.$emit("isLoading", this.loadingImg);
        }, 500);
      });
    },
    uplaodFirstMaterialsInfo(req) {
      //console.log(req, "获取的文件数据");
      const file = req.file;
      var formData = new FormData();
      formData.append("Type", "第一学历");
      formData.append("Files", file);
      this.imgFirstInfo
        ? formData.append("EnableClearUpTheMaterialsForThisType", true)
        : formData.append("EnableClearUpTheMaterialsForThisType", false);
      uploadMaterials(this.id, formData).then((res) => {
        this.$message({
          message: "用户信息更新成功！",
          type: "success",
        });
        this.getMaterialList();
      });
    },
    uplaodSecondMaterialsInfo(req) {
      //console.log(req, "获取的文件数据");
      const file = req.file;
      var formData = new FormData();
      formData.append("Type", "第二学历");
      formData.append("Files", file);
      this.imgSecondInfo
        ? formData.append("EnableClearUpTheMaterialsForThisType", true)
        : formData.append("EnableClearUpTheMaterialsForThisType", false);
      uploadMaterials(this.id, formData).then((res) => {
        this.$message({
          message: "用户信息更新成功！",
          type: "success",
        });
        this.getMaterialList();
      });
    },
    uplaodThirdMaterialsInfo(req) {
      //console.log(req, "获取的文件数据");
      const file = req.file;
      var formData = new FormData();
      formData.append("Type", "第三学历");
      formData.append("Files", file);
      this.imgThirdInfo
        ? formData.append("EnableClearUpTheMaterialsForThisType", true)
        : formData.append("EnableClearUpTheMaterialsForThisType", false);
      if (this.isPIC && this.isLt5M) {
        uploadMaterials(this.id, formData).then((res) => {
          this.$message({
            message: "用户信息更新成功！",
            type: "success",
          });
          this.getMaterialList();
        });
      }
    },
    beforeAvatarUpload(file) {
      //console.log(file, "获取的file");
      this.isPIC = file.type === "image/jpeg" || file.type === "image/png";
      this.isLt5M = file.size / 1024 / 1024 < 5;
      if (!this.isPIC) {
        this.$message.error("只支持上传jpg/png文件");
      }
      if (!this.isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return this.isPIC && this.isLt5M;
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#currency {
  .update-box {
    @include flex(row, center);
    flex-wrap: wrap;
    .material-info {
      margin-bottom: 20px;
      .card-tit {
        margin-bottom: 20px;
        font-size: 12px;
        color: #666666;
      }
      .material-details {
        @include flex(row, center);
        flex-wrap: wrap;
        justify-content: flex-start;
        .img-details {
          .title {
            margin-bottom: 20px;
            color: #666;
          }
        }
        .img-box {
          @include flex(row, flex-end);
          border: 1px solid #dfdfdf;
          padding: 10px;
          margin-right: 20px;
          .el-image {
            width: 170px;
            height: 148px;
            text-align: center;
            ::v-deep .el-image__inner {
              max-width: 170px;
              width: auto;
            }
          }
          ::v-deep .el-image-viewer__close {
            color: #fff;
          }
          .img-info {
            margin-left: 10px;
            margin-bottom: 20px;
            .img-name {
              margin-bottom: 10px;
            }
            .img-btn {
              @include flex(row, center);
              margin-top: 10px;
              width: 180px;
              height: 12px;
              line-height: 12px;
              .upload-demo {
                margin-right: 10px;
                cursor: pointer;
                font-size: 12px;
                color: $--color-primary;
              }
              .btn {
                margin-right: 10px;
                cursor: pointer;
                font-size: 12px;
                color: $--color-primary;
              }
              .upload-file {
                display: none;
              }
            }
          }
        }
        .img-update {
          @include flex(row, center);
          justify-content: flex-start;
          width: 370px;

          .upload-tips {
            color: #bbb;
            span {
              font-size: 14px;
              color: $--color-primary;
            }
          }
        }
        // margin-bottom: 12px;
        ::v-deep .el-upload-dragger {
          border: 0;
        }
        ::v-deep .img-update .el-upload {
          border-radius: 0px;
          width: 350px;
          height: 170px;
          line-height: 190px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        ::v-deep .el-upload--picture-card {
          margin-right: 20px;
          width: 350px;
          height: 150px;
          border-radius: 0;
          border-color: #ddd;
        }
        .img-update .el-upload:hover {
          border-color: #409eff;
        }

        .avatar {
          @include flex(row, center);
          width: 178px;
          height: 400px;
          img {
            width: 50%;
            height: 100%;
          }
          .img-info {
            width: 100%;
            height: 100%;
          }
        }
      }

      .tips {
        margin-top: 12px;
        font-size: 12px;
        color: #888;
      }
    }
  }
}
</style>
